import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import { formatDateTime } from '../../utils';

const AutomationAuditLogsModal = ({ show, automationName, logs, loading, onClose }) => (
    <Modal show={show} onHide={onClose} size="lg" centered className="ns-modal">
        <Modal.Header closeButton>
            <Modal.Title>Audit Logs — {automationName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {loading ? (
                <div className="text-center">Loading...</div>
            ) : logs.length === 0 ? (
                <div className="text-center">No activity recorded yet</div>
            ) : (
                <Table className="table-sm" responsive>
                    <thead>
                        <tr><th>Action</th><th>Details</th><th>When</th></tr>
                    </thead>
                    <tbody>
                        {logs.map((log) => (
                            <tr key={log.id}>
                                <td style={{ textTransform: 'capitalize' }}>{log.action}</td>
                                <td>{log.message || '—'}</td>
                                <td>{formatDateTime(log.createdAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Modal.Body>
        <Modal.Footer>
            <button type="button" className="btn_theme_secondary" onClick={onClose}>Close</button>
        </Modal.Footer>
    </Modal>
);

export default AutomationAuditLogsModal;